<mat-card class="contenedor-transferencias" *appRole="['Comprobantes.Trasferencias.Ver']">

  <ngx-spinner [zIndex]="100" name="spTransferencias" bdColor="rgba(255,255,255,0.8)" size="default" color="#009688"
    type="ball-atom" [fullScreen]="false"></ngx-spinner>

  <!-- Filtros -->
  <form [formGroup]="form">
    <div class="row filtros-row">
      <div class="col-12 col-md-6 col-lg-4">
        <mat-form-field class="full-width">
          <mat-label>Rango de fechas</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate formControlName="FechaDesde" placeholder="Desde">
            <input matEndDate formControlName="FechaHasta" placeholder="Hasta">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </div>

      <div class="col-12 col-md-6 col-lg-3">
        <mat-form-field class="full-width">
          <mat-label>Rangos rápidos</mat-label>
          <mat-select formControlName="RangoFecha" (selectionChange)="selectRangoFecha($event)">
            <mat-option [value]="fecha.id" *ngFor="let fecha of lstRangoFecha; trackBy: trackByItems">
              {{ fecha.descripcion | titlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-12 col-lg-5 acciones-filtro">
        <button mat-stroked-button color="primary" (click)="buscar()">
          <mat-icon>filter_alt</mat-icon>
          Filtrar
        </button>
        <button mat-stroked-button color="primary" (click)="limpiar()">
          <mat-icon>clear_all</mat-icon>
          Limpiar
        </button>
      </div>
    </div>
  </form>

  <!-- Resumen -->
  <div class="resumen" *ngIf="hayDatos">
    <span class="dato">
      <mat-icon>account_balance</mat-icon>
      <b>{{ getCantidadTransferencias() }}</b> transferencias
    </span>
    <span class="dato total">
      <mat-icon>payments</mat-icon>
      Total a transferir: <b>{{ getTotalGeneral() | currency }}</b>
    </span>

    <span class="dato seleccionado" *ngIf="seleccion.hasValue()">
      <mat-icon>check_circle</mat-icon>
      Seleccionado: <b>{{ getTotalSeleccionado() | currency }}</b>
      ({{ seleccion.selected.length }})
    </span>

    <!-- Genera el TXT de ancho fijo para importar en el homebanking.
         Sólo exporta: no marca los comprobantes como pagados. -->
    <div class="bloque-exportar" *appRole="['Comprobantes.Descargar']">

      <mat-form-field class="select-banco" *ngIf="templatesBanco.length > 0">
        <mat-label>Banco destino</mat-label>
        <mat-select [(value)]="idBancoExportacion">
          <mat-option *ngFor="let t of templatesBanco; trackBy: trackByItems" [value]="t.banco.id">
            {{ t.banco.descripcion }}
          </mat-option>
        </mat-select>
        <mat-hint>Define el formato del archivo</mat-hint>
      </mat-form-field>

      <!-- Sin template no hay formato: el archivo saldría vacío -->
      <span class="sin-template" *ngIf="templatesBanco.length === 0">
        <mat-icon>error_outline</mat-icon>
        No hay ningún banco parametrizado.
      </span>

      <button mat-icon-button color="primary" (click)="irAParametrizacion()"
        matTooltip="Editar el formato del archivo de cada banco">
        <mat-icon>settings</mat-icon>
      </button>

      <button mat-raised-button color="primary" class="btn-exportar"
        [disabled]="!seleccion.hasValue() || exportando || templatesBanco.length === 0"
        matTooltip="Genera el archivo de transferencias para importar en el banco. No marca los comprobantes como pagados."
        (click)="exportarArchivoBanco()">
        <mat-icon>account_balance_wallet</mat-icon>
        Exportar al banco
      </button>
    </div>
  </div>

  <div class="tabla-container">
    <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="tabla-transferencias">

      <ng-container matColumnDef="seleccion">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="alternarTodas()"
            [checked]="seleccion.hasValue() && estanTodasSeleccionadas()"
            [indeterminate]="seleccion.hasValue() && !estanTodasSeleccionadas()"
            matTooltip="Seleccionar todas">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let grupo">
          <mat-checkbox (click)="$event.stopPropagation()"
            (change)="seleccion.toggle(grupo)"
            [checked]="seleccion.isSelected(grupo)">
          </mat-checkbox>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="propietario">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Propietario</th>
        <td mat-cell *matCellDef="let grupo">
          <strong>{{ grupo.propietario }}</strong>
          <span class="aviso-anuladas" *ngIf="grupo.cantidadAnuladas > 0"
            matTooltip="Estas liquidaciones no suman al total a transferir">
            <mat-icon>do_not_disturb_on</mat-icon>
            {{ grupo.cantidadAnuladas }} anulada(s)
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef><strong>Total general</strong></td>
      </ng-container>

      <ng-container matColumnDef="fechaEmision">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha</th>
        <td mat-cell *matCellDef="let grupo">{{ grupo.fechaEmision | date: 'dd/MM/yyyy' }}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="liquidaciones">
        <th mat-header-cell *matHeaderCellDef>Liquidaciones</th>
        <td mat-cell *matCellDef="let grupo">
          <span class="badge-cantidad">{{ grupo.cantidadLiquidaciones }}</span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="totalCalculo">
        <th mat-header-cell *matHeaderCellDef class="text-right">Total de cálculo</th>
        <td mat-cell *matCellDef="let grupo" class="text-right importe-haber">
          <span *ngIf="grupo.tieneDesglose; else sinDatoCalculo">{{ grupo.totalCalculo | currency }}</span>
          <ng-template #sinDatoCalculo>
            <span class="sin-dato" matTooltip="Liquidación anterior a que se guardara este total">—</span>
          </ng-template>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="totalComisiones">
        <th mat-header-cell *matHeaderCellDef class="text-right">Comisiones</th>
        <td mat-cell *matCellDef="let grupo" class="text-right importe-debe">
          <span *ngIf="grupo.tieneDesglose; else sinDatoComision">{{ grupo.totalComisiones | currency }}</span>
          <ng-template #sinDatoComision>
            <span class="sin-dato" matTooltip="Liquidación anterior a que se guardara este total">—</span>
          </ng-template>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="totalATransferir">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-right">A transferir</th>
        <td mat-cell *matCellDef="let grupo" class="text-right importe-transferir">
          <strong>{{ grupo.totalATransferir | currency }}</strong>
        </td>
        <td mat-footer-cell *matFooterCellDef class="text-right importe-transferir">
          <strong>{{ getTotalGeneral() | currency }}</strong>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandir">
        <th mat-header-cell *matHeaderCellDef aria-label="detalle">&nbsp;</th>
        <td mat-cell *matCellDef="let grupo">
          <button mat-icon-button (click)="expandir(grupo); $event.stopPropagation()"
            [matTooltip]="filaExpandida === grupo ? 'Ocultar detalle' : 'Ver liquidaciones'">
            <mat-icon>{{ filaExpandida === grupo ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
          </button>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Detalle: las liquidaciones que componen la transferencia -->
      <ng-container matColumnDef="detalle">
        <td mat-cell *matCellDef="let grupo" [attr.colspan]="columnasConExpansion.length">
          <div class="detalle-grupo" [@detailExpand]="grupo === filaExpandida ? 'expanded' : 'collapsed'">
            <table mat-table [dataSource]="grupo.liquidaciones" class="tabla-detalle">

              <ng-container matColumnDef="numeroComprobante">
                <th mat-header-cell *matHeaderCellDef>Comprobante</th>
                <td mat-cell *matCellDef="let liq">{{ liq.numeroComprobante }}</td>
              </ng-container>

              <ng-container matColumnDef="propiedad">
                <th mat-header-cell *matHeaderCellDef>Propiedad</th>
                <td mat-cell *matCellDef="let liq">{{ liq.propiedad }}</td>
              </ng-container>

              <ng-container matColumnDef="contrato">
                <th mat-header-cell *matHeaderCellDef>Contrato</th>
                <td mat-cell *matCellDef="let liq">{{ liq.numeroContrato }}</td>
              </ng-container>

              <ng-container matColumnDef="inquilino">
                <th mat-header-cell *matHeaderCellDef>Inquilino</th>
                <td mat-cell *matCellDef="let liq">{{ liq.inquilino }}</td>
              </ng-container>

              <ng-container matColumnDef="estado">
                <th mat-header-cell *matHeaderCellDef>Estado</th>
                <td mat-cell *matCellDef="let liq">
                  <span [class.estado-anulado]="liq.anulado">{{ liq.estado }}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="total">
                <th mat-header-cell *matHeaderCellDef class="text-right">Total</th>
                <td mat-cell *matCellDef="let liq" class="text-right"
                  [class.importe-anulado]="liq.anulado">
                  {{ liq.total | currency }}
                </td>
              </ng-container>

              <ng-container matColumnDef="accion">
                <th mat-header-cell *matHeaderCellDef>Acción</th>
                <td mat-cell *matCellDef="let liq">
                  <button mat-icon-button color="primary" matTooltip="Ver comprobante"
                    (click)="verComprobante(liq)">
                    <mat-icon>visibility</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="columnasDetalle"></tr>
              <tr mat-row *matRowDef="let fila; columns: columnasDetalle"
                [class.fila-anulada]="fila.anulado"></tr>
            </table>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnasConExpansion; sticky: true"></tr>
      <tr mat-row *matRowDef="let fila; columns: columnasConExpansion" class="fila-grupo"
        (click)="expandir(fila)"></tr>
      <tr mat-row *matRowDef="let fila; columns: ['detalle']" class="fila-detalle"></tr>
      <tr mat-footer-row *matFooterRowDef="columnasConExpansion" class="fila-total"></tr>
    </table>

    <app-sin-datos *ngIf="!hayDatos" mensaje="No se encontraron liquidaciones en el período seleccionado"></app-sin-datos>
  </div>

  <mat-paginator showFirstLastButtons [pageSize]="20" [pageSizeOptions]="[10, 20, 50, 100]">
  </mat-paginator>

</mat-card>
